import {useTypedSelector} from "@hooks/useTypedSelector";
import {useEffect, useReducer, useState, useRef} from "react";
import {useActions, useGeoZoneSliceActions} from "@hooks/useActions";
import {reducer, actions as actionBlanks, initialState} from "./state";
import {ApplicationDataState} from "@pages/partners/items/drones/form/types";
import {bindActionCreators} from "@reduxjs/toolkit";
import ApplicationService from "@api/partners/ApplicationService";
import FormBody from "./components/formBody/FormBody"
import ApplicationForm from "@pages/partners/components/applicationForm/ApplicationForm";
import st from "@pages/partners/items/drones/form/form.module.scss";

const Form = ({hideWindow}: { hideWindow: () => void }) => {

    const {
        operations,
        goods: {goods, goodsGroups, goodsCategories},
        auth,
        users,
        geoZones,
    } = useTypedSelector(state => state);

    const {
        fetchReferenceOperations,
        fetchPartnersGoods,
        fetchPartnersGoodsGroups,
        fetchPartnersGoodsCategories,
        fetchPartnersUsers,
    } = useActions();

    const {fetch: fetchGeoZones} = useGeoZoneSliceActions();

    useEffect(() => {
        fetchReferenceOperations();
        fetchPartnersGoods();
        fetchPartnersGoodsGroups();
        fetchPartnersGoodsCategories();
        fetchPartnersUsers({});
        fetchGeoZones();
    }, []);

    useEffect(() => {
        const name = auth.accessToken?.userInfo.name;
        const userName = users.data.find(({title}) => title === name)?.title || name;
        actions.setCustomerName(userName);
    }, [users.data]);

    //@ts-ignore
    const [item, dispatch]: [ApplicationDataState, any] = useReducer(reducer, initialState);

    const actions = bindActionCreators(actionBlanks, dispatch);

    const [containerExist, setContainerExist] = useState(false);
    const containerRef = useRef<HTMLDivElement | null>(null);

    const options = {
        filteredOperations: operations.data.filter(({operationType}) => operationType === 'chemicalTrearment'),
        filteredGoods: (() => {
            const qualifiers = goodsCategories.data.filter(gc => gc.title === 'СЗР').map(({id}) => id);
            const groupsIds = goodsGroups.data.filter(gg => qualifiers.includes(gg.qualifier)).map(({id}) => id);
            return goods.data.filter(g => groupsIds.includes(g.group));
        })(),
        fields: geoZones.geoZonesByType.field.map(id => geoZones.entities[id]),
        square: item.polygonJson?.area?.toFixed(3),
    };

    return (
        <ApplicationForm
            style={{width: '662px'}}
            headingText={'Форма заявки на обработку поля дронами'}
            hideWindow={hideWindow}
            sendRequest={async () => ApplicationService.sendDrones({...item, square: options.square!})}
        >
            {(isLoading) => (
                <div className={st['inputs']} ref={(c) => {
                    containerRef.current = c;
                    setContainerExist(Boolean(c));
                }}>
                    {(!isLoading && containerExist) && <FormBody
                        item={item}
                        actions={actions}
                        options={options}
                        container={containerRef.current!}
                    />}
                </div>)}
        </ApplicationForm>
    );
};

export default Form;